import { Store, Module, ActionContext } from "vuex";
import ListModule from "../list-module";
import ListState from "../list-state";
import Ajax from "../../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import ListMutations from "../list-mutations";
import Coupon from "../../entities/booking/coupon";

interface CouponState extends ListState<Coupon> {
  editCoupon: Coupon;
}
class CouponModule extends ListModule<CouponState, any, Coupon> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Coupon>(),
    loading: false,
    editCoupon: new Coupon(),
  };
  actions = {
    async getAll(context: ActionContext<CouponState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Coupon/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<Coupon>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<CouponState, any>, payload: any) {
      await Ajax.post("/api/services/app/Coupon/Create", payload.data);
    },
    async createWithImages(
      context: ActionContext<CouponState, any>,
      payload: any
    ) {
      await Ajax.post(
        "/api/services/app/Coupon/CreateWithImages",
        payload.data
      );
    },
    async update(context: ActionContext<CouponState, any>, payload: any) {
      await Ajax.put("/api/services/app/Coupon/Update", payload.data);
    },
    async updateWithImages(
      context: ActionContext<CouponState, any>,
      payload: any
    ) {
      await Ajax.put("/api/services/app/Coupon/UpdateWithImages", payload.data);
    },
    async delete(context: ActionContext<CouponState, any>, payload: any) {
      context.state.loading = true;
      await Ajax.delete(
        "/api/services/app/Coupon/Delete?Id=" + payload.data.id
      );
      context.state.loading = false;
    },
    async get(context: ActionContext<CouponState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/Coupon/Get?Id=" + payload.id
      );
      return reponse.data.result as Coupon;
    },
     async getListByCouponId(context: ActionContext<CouponState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/CouponValidPeriod/GetListByCouponId?Id=" + payload.id
      );
      return reponse.data.result as any;
    },
    async CreateCourtCouponForAllUsers(
      context: ActionContext<CouponState, any>,
      payload: any
    ) {
      console.log(payload.data, "datadata");
      let reponse = Ajax.post(
        "/api/services/app/Coupon/CreateCourtCouponForAllUsers",
        payload.data
      );
      return reponse;
    },
  };
  mutations = {
    setCurrentPage(state: CouponState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: CouponState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: CouponState, coupon: Coupon) {
      state.editCoupon = coupon;
    },
    changeLoading(state: CouponState, pass: boolean) {
      state.loading = pass;
    },
  };
}
const couponModule = new CouponModule();
export default couponModule;
